import Vue from 'vue'
import VeeValidate, {Validator} from 'vee-validate'

Validator.extend('max16digit', {
  getMessage: field => `The ${field} field may contain up to 16 digits.`,
  validate: value => {
    const test = value.match(/\d+/g)

    if (test) {
      return test.join('').length <= 16
    } else {
      return true
    }
  }
})

Validator.extend('phone', {
  getMessage: field => `The ${field} field accepts up to 16 digits, “-“, “+”, “(“ and “)”.`,
  validate: value => !(/[^\d\(\)\-\+\s]/.test(value))
})

Validator.extend('excluded', {
  validate: (value, args) => {
    if (args.length) {
      return args.indexOf(value) === -1
    } else {
      return true
    }
  }
})

Vue.use(VeeValidate, {
  events: 'blur',
  delay: 100,
  fieldsBagName: 'inputs',
  dictionary: {
    en: {
      // messages: {
      //   required: () => 'Field is required',
      //   numeric: () => 'Field may only contain numeric characters',
      //   integer: () => 'Field must be an integer'
      // },
      custom: {
        key: {
          excluded: 'Key already used.'
        }
      }
    }
  }
})


// WEBPACK FOOTER //
// ./src/plugins/vee-validate.js